import { listingReducer } from "../reducers/utils/listingReducer";
import { getPackageInquires } from "../../services/inquiries";

const { reducer, actions, types } = listingReducer({
  name: `packageInq`,
  getApi: getPackageInquires,
});
const packageInq = reducer;
export { packageInq, actions, types };
